import * as THREE from 'three';

interface InteractionSceneOptions {
  geometry: [number, number, number];
  cuttingInfoPaths: any; // 替换为实际类型
  relativePosition?: any; // 替换为实际类型
  geometryPos: [number, number, number];
  onInteractionSceneCallback?: (data: {
    playerPosition: THREE.Vector3;
    cuttingInfoPaths: any;
    box: THREE.Box3;
  }) => void;
  visible?: boolean;
}
export class InteractionScene {
  scene: THREE.Scene | null = null;
  zone: THREE.Mesh | null = null;
  box: THREE.Box3 | null = null;
  cuttingInfoPaths: any | null = null; // 替换为实际类型
  relativePosition: any | null = null; // 替换为实际类型
  onInteractionSceneCallback:
    | ((data: { playerPosition: THREE.Vector3; cuttingInfoPaths: any; box: THREE.Box3 }) => void)
    | null = null;

  constructor(scene: THREE.Scene, options: InteractionSceneOptions) {
    const { geometry, cuttingInfoPaths, relativePosition, geometryPos, onInteractionSceneCallback } = options;
    if (!geometry || !cuttingInfoPaths || !geometryPos) throw new Error('geometry, cuttingInfoPaths is null');
    this.cuttingInfoPaths = cuttingInfoPaths;
    this.relativePosition = relativePosition;

    onInteractionSceneCallback && (this.onInteractionSceneCallback = onInteractionSceneCallback);

    // 创建一个完全透明的交互区域
    const boxGeometry = new THREE.BoxGeometry(...geometry);
    const material = new THREE.MeshBasicMaterial({
      color: 0x00ff00,
      transparent: true,
      // opacity: 0.0, // 完全透明
      visible: options.visible || false, // 不可见
    });
    this.zone = new THREE.Mesh(boxGeometry, material);

    // 设置交互区域的位置（可以根据需要调整）
    this.zone.position.set(...geometryPos);

    // 将交互区域添加到场景中
    scene.add(this.zone);

    // 创建一个用于检测碰撞的包围盒
    this.box = new THREE.Box3().setFromObject(this.zone);
  }

  // 检测玩家是否在交互区域内
  checkInteractionZone(playerPosition: THREE.Vector3): void {
    if (!this.zone || !this.box) return;

    // 创建一个点来表示玩家位置
    const playerPoint = new THREE.Vector3(playerPosition.x, playerPosition.y, playerPosition.z);

    // 检查玩家是否在交互区域内
    const isInZone = this.box.containsPoint(playerPoint);

    // 如果设置了回调函数，则调用它
    if (this.onInteractionSceneCallback && isInZone) {
      this.onInteractionSceneCallback({ playerPosition, cuttingInfoPaths: this.cuttingInfoPaths, box: this.box });
    }
  }
}
